<template>
  <div class="pricing-card">
    <div class="card-header">
      <div class="header-content">
        <h3 class="card-title">{{ data.planCode }}</h3>
        <div class="actions">
          <button @click="clickTermsCondition" class="terms-button">
            {{ $t("customers.label.ViewT&C") }}
          </button>
        </div>
      </div>
      <div class="features" v-if="!isAddon">
        <div
          v-for="(feature, index) in filteredContentData"
          :key="index"
          class="feature"
          v-if="feature.planId === data.id"
        >
          <div
            v-for="(item, idx) in feature.items"
            :key="idx"
            class="feature-item ml-2"
          >
            <feather-icon
              icon="CheckCircleIcon"
              class="check-icon"
            ></feather-icon>
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="plans-container">
        <div class="plans-wrapper">
          <div
            v-for="(plan, index) in filteredPlanData"
            :key="index"
            class="plan"
            :class="{
              selected:
                selectedPlanProp === data.id * 10 + index ||
                selectedAddonProp === data.id * 30 + index ||
                selectedPlan.includes(index),
            }"
            @click="selectPlan(index, plan)"
          >
            <div class="plan-duration">
              {{ plan.duration }}
            </div>
            <div class="plan-price">
              {{ data.symbol }} {{ plan.finalPrice.toFixed(2) }}
              <span class="per-duration" v-if="type == 'Postpaid'"
                >/ 1 Month</span
              >
            </div>
            <div v-if="plan.price && plan.rate > 0" class="original-price">
              <span class="strikethrough"
                >{{ data.symbol }}{{ plan.price.toFixed(2) }}</span
              >
              <span class="savings">Save {{ plan.rate }}%</span>
            </div>
          </div>
          <div class="features" v-if="isAddon">
            <div
              v-for="(feature, index) in filteredContentData"
              :key="index"
              class="feature"
              v-if="feature.planId === data.id"
            >
              <div
                v-for="(item, idx) in feature.items"
                :key="idx"
                class="feature-item ml-2"
              >
                <feather-icon
                  icon="CheckCircleIcon"
                  class="check-icon"
                ></feather-icon>
                <span>{{ item }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('Terms & Conditions')"
        :active.sync="termsConditionPopup"
        class="popup-close mid-popup upper-popup"
      >
        <div v-if="selectedTermsCondition">
          <div v-html="selectedTermsCondition.text"></div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
export default {
  name: "PricingCard",
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
    isAddon: {
      type: Boolean,
      default: false,
    },
    type: String,
    selectedPlanProp: {
      type: [Number, String],
    },
    selectedAddonProp: {
      type: [Number, String],
    },
    contentData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      selectedPlan: [],
      termsConditionPopup: false,
      selectedTermsCondition: null,
    };
  },
  computed: {
    filteredPlanData() {
      let availableChannel = false;
      let filtered = this.data.priceDetails.filter((e) => {
        if (e.channel === "POS") {
          availableChannel = true;
        }
        return e.channel === "POS";
      });
      if (!availableChannel) {
        filtered = this.data.priceDetails;
      }
      const uniquePlans = [];
      const seenDurations = new Set();
      filtered.forEach((plan) => {
        if (!seenDurations.has(plan.duration)) {
          for (const temp of filtered) {
            if (temp.duration === plan.duration) {
              if (temp.offerType == "Discount") {
                plan.rate = temp.rate;
                plan.finalPrice = temp.finalPrice;
                break;
              }
            }
          }
          seenDurations.add(plan.duration);
          uniquePlans.push(plan);
        }
      });
      return uniquePlans;
    },
    filteredTermsConditionData() {
      return this.contentData
        .map((x) =>
          x
            .filter((content) => content.contentType === "Term&Condition")
            .map((content) => {
              return {
                ...content,
                items: this.removePTagsAndMakeArray(content.text),
              };
            })
        )
        .flat()
        .filter(
          (feature, index, self) =>
            index === self.findIndex((f) => f.planId === feature.planId)
        );
    },
    filteredContentData() {
      return this.contentData
        .map((x) =>
          x
            .filter(
              (content) =>
                content.contentType === "Feature_list" &&
                content.enumMessageProperty === "English"
            )
            .map((content) => {
              return {
                ...content,
                items: this.removePTagsAndMakeArray(content.text),
              };
            })
        )
        .flat()
        .filter(
          (feature, index, self) =>
            index === self.findIndex((f) => f.planId === feature.planId)
        );
    },
  },
  methods: {
    selectPlan(index, plan) {
      let content = {};
      for (const temp of this.filteredContentData) {
        if (temp.planId == this.data.id && temp.contentType == "Feature_list") {
          content = temp;
          break;
        }
      }
      if (!this.selectedPlanProp) {
        // this.selectedPlan.push(index);
      }
      this.$emit(
        "planClicked",
        plan,
        this.data,
        content,
        this.data.id * 10 + index,
        this.data.id * 30 + index
      );
    },
    removePTagsAndMakeArray(inputString) {
      if (!inputString) return [];
      const strippedString = inputString.replace(/<[^>]+>/g, "\n"); // Remove all HTML
      const resultArray = strippedString
        .split("\n")
        .map((item) => item.trim()) // Trim spaces
        .filter((item) => item !== ""); // Remove empty items
      return resultArray;
    },
    clickTermsCondition() {
      this.selectedTermsCondition = this.filteredTermsConditionData.find(
        (content) => content.planId === this.data.id
      );
      this.termsConditionPopup = true;
    },
  },
};
</script>

<style scoped>
.pricing-card {
  width: 100%;
  max-width: 48rem;
  margin: 0 auto;
  background-color: #f0f9ff;
  border-radius: 0.5rem;
  padding: 1.5rem;
}

.card-header {
  display: flex;
  flex-direction: column;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333333;
  margin: 0;
}

.features {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  flex-direction: row;
}

.feature {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 0.875rem;
  color: #666666;
}

.feature-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.check-icon {
  width: 1rem;
  height: 1rem;
  color: #4caf50;
  margin-right: 0.25rem;
}

.plans-container {
  overflow-x: auto;
  margin: 0 -1.5rem;
  padding: 0 1.5rem 1rem;
}

.plans-container::-webkit-scrollbar {
  height: 4px;
}

.plans-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.plans-wrapper {
  display: flex;
  gap: 1rem;
  min-width: min-content;
}

.plan {
  cursor: pointer;
  border-radius: 0.5rem;
  padding: 1rem;
  transition: background-color 0.3s, color 0.3s;
  min-width: 140px;
  background-color: white;
  flex-shrink: 0;
}

.plan:hover {
  background-color: #f5f5f5;
}

.plan.selected {
  background-color: #4caf50;
  color: white;
}

.plan-duration {
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.plan-price {
  font-size: 1.5rem;
  font-weight: 700;
}

.per-duration {
  font-size: 0.875rem;
  font-weight: 400;
}

.original-price {
  text-decoration: none !important;
  font-size: 0.875rem;
  color: #666666;
  margin-top: 0.25rem;
}

.plan.selected .original-price {
  color: rgba(255, 255, 255, 0.8);
}

.strikethrough {
  text-decoration: line-through;
}

.savings {
  margin-left: 0.5rem;
  color: #4caf50;
}

.plan.selected .savings {
  color: white;
}

.actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.buy-button {
  background-color: #4caf50;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.buy-button:hover {
  background-color: #45a049;
}

.terms-button {
  background: none;
  border: none;
  color: #666666;
  font-size: 0.75rem;
  cursor: pointer;
  text-decoration: underline;
}
</style>
